export const ADD_TO_FOOD_CART = 'ADD_TO_FOOD_CART';
export const REMOVE_FROM_FOOD_CART = 'REMOVE_FROM_FOOD_CART';
export const UPDATE_FOOD_CART_QUANTITY = 'UPDATE_FOOD_CART_QUANTITY';
export const CLEAR_FOOD_CART = 'CLEAR_FOOD_CART';
export const CREATE_FOOD_ORDER = 'CREATE_FOOD_ORDER';
export const GET_MY_FOOD_ORDERS = 'GET_MY_FOOD_ORDERS';
export const GET_ALL_FOOD_ORDERS = 'GET_ALL_FOOD_ORDERS';
export const UPDATE_FOOD_ORDER_STATUS = 'UPDATE_FOOD_ORDER_STATUS';
